import { render, staticRenderFns } from "./ReadSerial.vue?vue&type=template&id=44fa2b56&"
import script from "./ReadSerial.vue?vue&type=script&lang=js&"
export * from "./ReadSerial.vue?vue&type=script&lang=js&"
import style0 from "./ReadSerial.vue?vue&type=style&index=0&id=44fa2b56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports